module.exports = __webpack_public_path__ + "img/videoIcon.1602ce6e.png";